import { render } from "./RoundsList.vue?vue&type=template&id=7e31a408&scoped=true"
import script from "./RoundsList.vue?vue&type=script&lang=js"
export * from "./RoundsList.vue?vue&type=script&lang=js"

import "./RoundsList.vue?vue&type=style&index=0&id=7e31a408&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e31a408"]])

export default __exports__